<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <!-- <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{breadcrumbLabels.home}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'playerList' }">{{breadcrumbLabels.players}}</el-breadcrumb-item>
                <el-breadcrumb-item
                    v-if="editing && model"
                    :to="{ name: 'playerShow', params: { id: model.id } }"
                >{{ model.id }}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="editing">{{breadcrumbLabels.edit}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="!editing">{{breadcrumbLabels.new}}</el-breadcrumb-item>
            </el-breadcrumb> -->

      <h2 class="page-title"> {{ editing ? $t('table.edit') + ' ' + $t('entities.coach.singular') : $t('table.add') + ' ' + $t('entities.coach.singular') }}</h2>

            <el-form
                ref="form"
                :model="model"
                :label-position="labelPosition"
                :label-width="labelWidth"
                :rules="rules"
                @submit.native.prevent="save"
            >
                <div class="block">
                    <el-form-item 
                     :label="$t('entities.coach.prop.name')"
                      prop="name"
                    >
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-input v-model="model.name" ref="focus"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item 
                     :label="$t('entities.coach.prop.lastName')"
                     prop="lastName"
                    >
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-input v-model="model.lastName"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item 
                    :label="$t('entities.team.singular')"
                    prop="team">
                    <el-col :lg="11" :md="16" :sm="24">
                        <el-select
                        filterable
                        :disabled="editing || isClubManager"
                        v-loading="options.teams == null"
                        v-model="model.team"
                        value-key="id"
                        >
                        <template v-if="options.teams">
                            <el-option
                            v-for="option in options.teams"
                            :key="option.id"
                            :label="option.label"
                            :value="option"
                            />
                        </template>
                        </el-select>
                    </el-col>
                    </el-form-item>
                     <!-- Picture -->
                    <el-form-item 
                     :label="$t('entities.coach.prop.picture')"
                    >
                        <el-col :lg="11" :md="16" :sm="24">
                            <div class="coach-uploader" @click="toggleShow">
                                <img v-if="model.picture.url" class="avatar" :src="model.picture.url">
                                <i v-else class="el-icon-plus coach-uploader-icon"></i>
                              </div>
                            <my-upload field="img"
                                @crop-success="attachFileToModel"
                                v-model="show"
                                :width="300"
                                :height="300"
                                langType="es-MX"
                                img-format="png"></my-upload>
                        </el-col>
                       
                    </el-form-item>
                     <!-- Picture -->
                    <el-form-item 
                     :label="$t('entities.coach.prop.dni')"
                     prop="dni">
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-input  v-model="model.dni"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item 
                     :label="$t('entities.coach.prop.birthdate')"
                     prop="birthdate"
                     >
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-date-picker
                            v-model="model.birthdate"
                            format="dd-MM-yyyy"
                            type="date"
                            placeholder="Pick a day">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>

                    <el-form-item 
                     :label="$t('entities.coach.prop.email')"
                     prop="email">
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-input v-model="model.email"/>
                        </el-col>
                    </el-form-item>

                    <el-form-item 
                     :label="$t('entities.coach.prop.phone')"
                     prop="phone">
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-input v-model="model.phone"/>
                        </el-col>
                    </el-form-item>
                </div>

                <div class="button-group mt-3">
                    <el-button
                        @click="save()"
                        :disabled="loading"
                        type="primary"
                        icon="el-icon-fa-floppy-o"
                    >{{buttonLabels.save}}</el-button>
                    <el-button @click="back()" :disabled="loading" icon="el-icon-fa-times">{{buttonLabels.cancel}}</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import validators from "@/shared/form/validators";
import myUpload from 'vue-image-crop-upload';
import moment from 'moment';    // birthdate

export default {
    name: "app-coach-form",
    
    components: {   
        'my-upload': myUpload
    },

    props: {
        id: String,
        previous: String
    },

    data() {
        return {
           title: "Entrenadores" ,
           titleEditCoach: "Editar entrenador",
           titleNewCoach: "Nuevo entrenador",
           breadcrumbLabels: {
             home: "Inicio",
             players: "Jugadores",
             edit: "Editar",
             new: "Nuevo"
           },
           show: false,
           imgDataUrl: '', // the datebase64 url of created image
            buttonLabels: {
              save: "Guardar",
              cancel: "Cancelar"
            },

            rules: {
                name: validators.string({
                    label: "Nombre",
                    required: true
                }),
                lastName: validators.string({
                    label: "Apellidos",
                    required: true
                }),
                dni: validators.string({
                    label: "Dni/Nie/Passaporte",
                    required: false
                }),
                team: validators.hasOne({
                    label: 'Team',
                    required: true
                }),
                    email: validators.string({
                    label: "Email de contacto",
                    required: false
                }),
                phone: validators.string({
                    label: "Teléfono",
                    required: false
                })
            }
        };
    },

    created() {
        this.$store.dispatch("entities/coach/loadOptions");
        if (this.id) {
            this.$store
                .dispatch("entities/coach/edit", this.id)
                .catch(() => this.$router.push({ name: "coachList" }));
        } else {
            this.$store.dispatch("entities/coach/new");
        }
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/coach/clear");
        this.$store.dispatch("entities/team/clear");
        next();
    },

    computed: {
        ...mapGetters({
            model: "entities/coach/model",
            loading: "entities/coach/loading",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth",
            isClubManager: "entities/coach/isClubManager",
            options: "entities/coach/options"
        }),

        editing: state => !!state.id
    },

    methods: {
        save() {
            this.model.birthdate = moment(this.model.birthdate).format('YYYY-MM-DD')

            this.$refs.form.validate().then(valid => {
                if (!valid) {
                    return;
                }

                this.$store.dispatch("entities/coach/save").then(() => {
                    this.back();
                });
            });
        },

        back() {
            this.$router.go(-1) 
        },
        toggleShow() {
            this.show = !this.show;
        },
        attachFileToModel(imgDataUrl) {
            const data =  imgDataUrl.slice(22,imgDataUrl.length )
            const picture = { 
                name: "picture.png",
                size: data.length,
                dataB64: data,
                url: imgDataUrl
            }
            this.model.picture = picture
        }
    }
};
</script>

<style>
  .coach-uploader{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
  }
  .coach-uploader:hover {
    border-color: #409EFF;
  }
  .coach-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/entities/coach/coach-form.vue?47e45c26